import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCheckCricleFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 26,
	height: 27,
	viewBox: "0 0 26 27",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.0003 24.3334C7.01708 24.3334 2.16699 19.4833 2.16699 13.5001C2.16699 7.51683 7.01708 2.66675 13.0003 2.66675C18.9836 2.66675 23.8337 7.51683 23.8337 13.5001C23.8337 19.4833 18.9836 24.3334 13.0003 24.3334ZM11.9202 17.8334L19.5794 10.1732L18.0487 8.64133L11.9202 14.7697L8.85549 11.705L7.32366 13.2368L11.9202 17.8334Z",
		fill: "#357DED"
	})
});
export default SvgCheckCricleFill;
